import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useRouteChange = (callback: () => void) => {
  const location = useLocation();
  const prevLocationRef = useRef(location.pathname);

  useEffect(() => {
    // Only call callback if the location has actually changed
    if (prevLocationRef.current !== location.pathname) {
      callback();
      prevLocationRef.current = location.pathname;
    }
  }, [location.pathname, callback]);
};
